var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    { staticClass: "menu" },
    [
      _c(
        "el-menu",
        { attrs: { mode: "horizontal" } },
        [
          _vm.menuVisible("data", _vm.loginUserRoleId)
            ? _c(
                "el-submenu",
                { attrs: { index: "1", "popper-class": "trans-data" } },
                [
                  _vm.menuVisible("data", _vm.loginUserRoleId)
                    ? _c("template", { slot: "title" }, [
                        _c("div", [_vm._v("データ登録")])
                      ])
                    : _vm._e(),
                  _vm.menuVisible("flight-data", _vm.loginUserRoleId)
                    ? _c(
                        "el-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/data/flight-data" } },
                            [_vm._v("運航データ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.menuVisible("hangar-usages-data", _vm.loginUserRoleId)
                    ? _c(
                        "el-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/data/hangar-usages-data" } },
                            [_vm._v("格納庫使用データ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.menuVisible("merge-data", _vm.loginUserRoleId)
                    ? _c(
                        "el-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/data/merge-data" } },
                            [_vm._v("着離陸・入出庫データ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.menuVisible(
                    "landing-passengers-data",
                    _vm.loginUserRoleId
                  )
                    ? _c(
                        "el-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/data/landing-passengers-data" } },
                            [_vm._v("着陸時有償旅客データ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.menuVisible(
                    "takeoff-passengers-data",
                    _vm.loginUserRoleId
                  )
                    ? _c(
                        "el-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/data/takeoff-passengers-data" } },
                            [_vm._v("離陸時有償旅客データ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm.menuVisible("calculation", _vm.loginUserRoleId)
            ? _c(
                "el-submenu",
                { attrs: { index: "2", "popper-class": "calc" } },
                [
                  _vm.menuVisible("calculation", _vm.loginUserRoleId)
                    ? _c("template", { slot: "title" }, [
                        _c("div", [_vm._v("料金計算")])
                      ])
                    : _vm._e(),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: "/calculation/fees-for-weight-and-noise"
                          }
                        },
                        [_vm._v("着陸料［重量・騒音］")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: "/calculation/fees-for-paid-passengers" }
                        },
                        [_vm._v("着陸料［有償旅客］")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/calculation/fees-for-stop" } },
                        [_vm._v("停留料")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/calculation/fees-for-security" } },
                        [_vm._v("保安料")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.menuVisible("invoice", _vm.loginUserRoleId)
            ? _c(
                "el-submenu",
                { attrs: { index: "3", "popper-class": "invoice" } },
                [
                  _vm.menuVisible("invoice", _vm.loginUserRoleId)
                    ? _c("template", { slot: "title" }, [
                        _c("div", [_vm._v("請求書管理")])
                      ])
                    : _vm._e(),
                  _vm.menuVisible("invoice-operation", _vm.loginUserRoleId)
                    ? _c(
                        "el-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/invoice/invoice-operation" } },
                            [_vm._v("請求書一覧")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.menuVisible("invoice-inquiry", _vm.loginUserRoleId)
                    ? _c(
                        "el-menu-item",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/invoice/invoice-inquiry" } },
                            [_vm._v("請求書照会")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm.menuVisible("simulation", _vm.loginUserRoleId)
            ? _c("el-menu-item", [_c("div", [_vm._v("料金シミュレーション")])])
            : _vm._e(),
          _vm.menuVisible("master", _vm.loginUserRoleId)
            ? _c(
                "el-submenu",
                { attrs: { index: "5", "popper-class": "master-data" } },
                [
                  _vm.menuVisible("master", _vm.loginUserRoleId)
                    ? _c("template", { slot: "title" }, [
                        _c("div", [_vm._v("マスタ管理")])
                      ])
                    : _vm._e(),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/master/registration-symbol-master" } },
                        [_vm._v("登録機マスタ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/master/customer-master" } },
                        [_vm._v("顧客マスタ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/master/airport-master" } },
                        [_vm._v("空港マスタ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/master/user-master" } },
                        [_vm._v("担当者マスタ")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.menuVisible("fee_master", _vm.loginUserRoleId)
            ? _c(
                "el-submenu",
                { attrs: { index: "6", "popper-class": "fee-master" } },
                [
                  _vm.menuVisible("fee_master", _vm.loginUserRoleId)
                    ? _c("template", { slot: "title" }, [
                        _c("div", [_vm._v("料金管理")])
                      ])
                    : _vm._e(),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: "/fee-master/fees-for-weight-and-noise" }
                        },
                        [_vm._v("着陸料［重量・騒音］")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: "/fee-master/fees-for-paid-passengers" }
                        },
                        [_vm._v("着陸料［有償旅客］")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/fee-master/fees-for-stop" } },
                        [_vm._v("停留料")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-menu-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/fee-master/fees-for-security" } },
                        [_vm._v("保安料")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }